<script setup>
import {ref, watch, defineProps, defineEmits} from "vue"

const props = defineProps({
  modelValue: {type: Object, required: true},
  loading: {type: Boolean, default: false}
})

const emit = defineEmits(["update:modelValue", "save", "cancel"])

const localForm = ref({...props.modelValue})
const isFormValid = ref(false) // <-- validity tracking

watch(
    () => props.modelValue,
    (newVal) => {
      if (JSON.stringify(newVal) !== JSON.stringify(localForm.value)) {
        localForm.value = {...newVal}
      }
    },
    {deep: true}
)

const formRef = ref(null)

const requiredRule = (v) => !!v || "This field is required"

function submitForm() {
  if (formRef.value.validate()) {
    emit("save", localForm.value)
  }
}
</script>

<template>
  <v-form ref="formRef" v-model="isFormValid">
    <v-text-field
        v-model="localForm.operatorProfileId"
        :disabled="props.loading"
        :rules="[requiredRule]"
        label="Operator Profile ID"
        required
    />
    <v-text-field
        v-model="localForm.username"
        :disabled="props.loading"
        :rules="[requiredRule]"
        label="Username"
        required
    />
    <v-text-field
        v-model="localForm.password"
        :disabled="props.loading"
        :rules="[requiredRule]"
        label="Password"
        required
        type="password"
    />

    <v-text-field
        v-model="localForm.workstationIp"
        :disabled="props.loading"
        :rules="[requiredRule]"
        label="Workstation IP"
        required
    />
    <v-select
        v-model="localForm.role"
        :disabled="props.loading"
        :items="['Admin', 'OCC', 'LSB', 'Depot']"
        :rules="[requiredRule]"
        label="Role"
        required
    />

    <v-divider class="my-3"/>

    <div class="d-flex justify-end">
      <v-btn :disabled="props.loading" variant="plain" @click="emit('cancel')">Close</v-btn>
      <v-btn
          :disabled="props.loading || !isFormValid"
          class="ml-2"
          color="primary"
          variant="tonal"
          @click="submitForm"
      >
        <span v-if="props.loading">Saving...</span>
        <span v-else>Register</span>
      </v-btn>
    </div>
  </v-form>
</template>
